import React from 'react';
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';

import './styles.scss';

const SacScoreBall: React.FC<{ score: number; }> = (props) => {
  const { score } = props;

  return (
    <Row className="sac-score-ball">
      <Text className="font-bold color-white" size={28}>
        {score?.toFixed(1)}
      </Text>
    </Row>
  );
};

export default SacScoreBall;
